import { useParams } from 'react-router'
import { useDocumentInspect } from '../api/documents'

export function ReservationDocumentInspect() {
	const { id } = useParams()
	const { data } = useDocumentInspect(id as string)

	return <pre>{JSON.stringify(data, null, 4)}</pre>
}
